import { IntlShape } from 'react-intl';
import { getPhotoConfigs } from 'routes/installation/const/config/photo';
import { InstallMeterStore } from 'routes/installation/useStore';

export const selectIsInstallMeterPhotoStepOK = (intl: IntlShape, state: InstallMeterStore): boolean => {
  type InstallationMeterStoreKey = keyof typeof state;
  const { enmonMeter } = state;

  const config = enmonMeter ? getPhotoConfigs(intl, enmonMeter) : [];

  return !config.some(
    ({ formItemName, required }) => required && state[formItemName as InstallationMeterStoreKey] === undefined,
  );
};
